import type { SchemaTab } from "./api";

/**
 * Tab names in the spreadsheet this dashboard is built for. The whole app is
 * bound to one Google Sheet, so the mapping lives here in one place instead of
 * being spread across pages.
 */
export const MASTER_TAB = "MASTER DATA";
export const DAILY_TAB = "HARIAN";
export const WEEKLY_TAB = "MINGUAN";

/**
 * Tab feeding the dashboard charts: the daily tab, else the first tab that
 * actually carries a date column (charts aggregate over dates).
 */
export function dashboardTab(tabs: SchemaTab[]): SchemaTab | null {
  const daily = tabs.find((tab) => tab.name === DAILY_TAB);
  if (daily) return daily;
  return tabs.find((tab) => tab.columns.some((column) => column.type === "date")) ?? null;
}
